export const annotatorQueueMessagesEn = {
  // Header section
  'annotatorQueue.header.title': 'Encounters',
  'annotatorQueue.header.stats.total.title': 'Total',
  'annotatorQueue.header.stats.pending.title': 'Pending',
  'annotatorQueue.header.stats.draft.title': 'Draft count',
  'annotatorQueue.header.stats.finalized.title': 'Finalized',
  'annotatorQueue.header.stats.completed.title': 'Completed',
};
